import * as TinyPubSub from 'helper/TinyPubSub';
import mergeDataSyncObjects from 'helper/LearningSpaceServices/utils/mergeDataSyncObjects';
import { getAllDataSyncObjects } from 'helper/LearningSpaceServices/LocalStore';
import User from 'helper/currentUser';

const user = new User();

const getAllInProgressStates = async () => {
  const allDataSyncObjects = await getAllDataSyncObjects();
  if (allDataSyncObjects.length > 0) {
    const mergedDSOs = mergeDataSyncObjects(allDataSyncObjects);
    return mergedDSOs.stateIds;
  }
  return [];
};

const getCardIdsInSync = async (cardIdsArray) => {
  const allInProgressStateIds = await getAllInProgressStates();
  return cardIdsArray.filter(cardId => allInProgressStateIds.includes(user.id() + '_' + cardId));
};

const dSOsUpdate = (cardIdsArray, changeCallBack) => async () => {
  const cardIdsInSync = await getCardIdsInSync(cardIdsArray);
  return changeCallBack(cardIdsInSync);
};

export const cardProgressSyncStatus = async (
  cardIdsArray,
  { init = false, changeCallBack = () => {} } = {}
) => {
  if (init) {
    TinyPubSub.unsubscribe('oneDataSyncObjectsUpdated');
    TinyPubSub.subscribe('oneDataSyncObjectsUpdated', dSOsUpdate(cardIdsArray, changeCallBack));
  }
  const cardIdsInSync = await getCardIdsInSync(cardIdsArray);
  return cardIdsInSync;
};
